<ng-template>
  <div class="sos-panel mat-elevation-z3">
    <div class="sos-panel-header">
      <mat-icon svgIcon="warning" class="hdr-icon"></mat-icon>
      <div class="hdr-text">
        <span class="title">{{ 'SOS.PANEL_TITLE' | translate }}</span>
        <span class="subtitle">{{ (sosService.alerts$ | async)?.length || 0 }} {{ 'SOS.AWAITING' | translate }}</span>
      </div>
      <button type="button" class="hdr-close" (click)="closed.emit()" [attr.aria-label]="'SOS.CLOSE' | translate">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>

    <div class="sos-panel-body">
      @if (sosService.alerts$ | async; as alerts) { @if (!alerts.length) {
      <div class="sos-empty">
        <mat-icon svgIcon="check_circle" class="ok-icon"></mat-icon>
        <span>{{ 'SOS.ALL_CLEAR' | translate }}</span>
      </div>
      } @for (alert of alerts; track alert.id) {
      <lin-sos-alert
        [alert]="alert"
        [isClient]="isClient"
        (acknowledge)="openAcknowledge(alert)"
        (viewOnMap)="viewOnMap(alert)"
      ></lin-sos-alert>
      } }
    </div>
  </div>
</ng-template>
